import api from "@services/apiList";
import instance from "@services/services";
import type { AiClinicWalletItem } from "../Types/AiWallet/AiWalletTypes";
import type { ResponseType } from "../Types/ServicesType/servicesType";

export const fetchAiClinicWalletService = async (): Promise<
  ResponseType<AiClinicWalletItem[]>
> => {
  const result = await instance.get(api.voiceAssistantApi.fetchClinicWallet);
  return result.data;
};
